import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { toJS } from "mobx";
import { observer, inject } from "mobx-react";
import {
  GridContainer,
  GridRow,
  GridColumn,
  Utils,
  Modal,
} from "arv-reactcomponents";
import {
  isDesktop,
  setPageType,
  queryParamsToObject,
  somethingWentWrong,
  getCurrentHref,
} from "../../utils";
import { pageType } from "../../constants";
import { MobileFilterContainer } from "../../component/MobileFilters";
import ProductFilters from "../../component/ProductFilters";
import ProductList from "../../component/ProductList";
import ProductListTopbar from "../../component/ProductListTopbar";
// import SelectedFilters from "../../component/SelectedFilters";
import BodyOverlay from "../../component/BodyOverlay";
import Analytics from "../../analytics";
import GTM from "../../analytics/GTM";
import Event from "../../analytics/eventFactory";
// import ListingBackToTop from "../../component/ListingBackToTop";
import ListingBanner from "../../component/ListingBanner";
// import ListingSearchBar from "../../component/ListingSearchBar";
import OmniView from "../../component/OmniView";
import StickyFilterBlock from "../../component/ProductFilters/StickyFilterBlock";
import MobileFilterButtons from "../../component/MobileFilters/MobileFilterButton";

const INFINITE_SCROLL_OFFSET = 2000;

@inject("ProductStore", "FooterStore")
@observer
class Listing extends Component {
  static removeBodyScrollHeight() {
    document.querySelector(".nw-app-body").style.minHeight = null;
  }

  static windowLocation() {
    const { pathname, search } = window.location;
    return `${pathname}${search}`;
  }

  static trackPageNumber(pageNo) {
    Analytics.trackEvent({
      action: Event.action.getListPageNo(pageNo),
      label: Event.label.getSource(window.pageType),
      category: Event.category.LISTING_PAGE,
    });
  }

  static decidePageType() {
    const pagePath = window.location.pathname;
    const pageUrl = getCurrentHref();
    const searchUrls = [`/${Event.category.SEARCH}`];
    const isSearchPage = searchUrls.includes(pagePath);
    return isSearchPage
      ? `${Event.category.SEARCH}_${pageUrl}`
      : `${Event.category.LISTING_PAGE}_${pageUrl}`;
  }
  static returnCurrentCollectionId(props) {
    const collectionIdFromWindowState =
      (window &&
        window.history &&
        window.history.state &&
        window.history.state.state &&
        window.history.state.state.collectionId) ||
      "";
    const collectionIdFromProps = props.ProductStore.collectionId;
    return collectionIdFromProps || collectionIdFromWindowState;
  }
  static returnCurrentType(props) {
    const typeFromWindowState =
      (window &&
        window.history &&
        window.history.state &&
        window.history.state.state &&
        window.history.state.state.type) ||
      "";
    const typeFromProps = props.ProductStore.type;
    return typeFromProps || typeFromWindowState;
  }

  constructor(props) {
    super(props);
    this.state = {
      omniView: false,
    };
    this.currentPageStats = {
      currentPage: pageType.listing,
      collectionId: Listing.returnCurrentCollectionId(props),
      type: Listing.returnCurrentType(props),
    };
    this.removeScrollListener = Utils.noop;
    this.removePopStateListener = Utils.noop;
    this.maintainScroll = this.maintainScroll.bind(this);
    this.initInfiniteScroll = this.initInfiniteScroll.bind(this);
    this.isListingScrollAtBottom = this.isListingScrollAtBottom.bind(this);
    this.updatePageNumber = this.updatePageNumber.bind(this);
    this.initialData = this.initialData.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.storeScrollInState = this.storeScrollInState.bind(this);
    this.triggerListingAfterOmni = this.triggerListingAfterOmni.bind(this);
    this.initializeListing = this.initializeListing.bind(this);
    this.initializeOmni = this.initializeOmni.bind(this);
  }
  componentDidMount() {
    this.initializeListing();
    this.initializeOmni();
  }

  componentWillUnmount() {
    this.removeScrollListener();
    this.removePopStateListener();
    this.props.ProductStore.toggleFilterView(false);
    this.props.FooterStore.changeFooterVisibleState(true);
    Listing.removeBodyScrollHeight();
  }

  get isScrollAtBottom() {
    return `${this.isListingScrollAtBottom()}`;
  }

  initializeOmni() {
    const { search } = this.props.location;
    const queryObj = queryParamsToObject(search);
    if (queryObj.when) {
      this.setState({
        omniView: true,
        omniViewType: queryObj.when,
      });
    }
  }
  initializeListing() {
    if (this.props.ProductStore.ProductData === null) {
      this.initialData();
    } else {
      this.initInfiniteScroll();
    }
    this.handleBrowserBack();
    this.props.ProductStore.toggleFilterView(true);
    this.props.FooterStore.changeFooterVisibleState(false);
    setPageType(pageType.listing);
    Analytics.pageView(window.pageType);
    Analytics.trackEvent({
      action: Event.action.LANDED,
      category: Event.category.LISTING_PAGE,
      label: Listing.decidePageType(),
      interaction: true,
    });
    GTM.pushEvent(Event.GTMEvent.LISTING);
    GTM.pushEvent(Event.GTMEvent.ADWORDS);
  }
  triggerListingAfterOmni(newUrl) {
    this.setState({
      omniView: false,
    });
    if (newUrl) {
      this.storeScrollInState(newUrl);
      this.props.ProductStore.clearProductData();
      this.initializeListing();
    }
  }
  handleBrowserBack() {
    const onPopState = () => {
      if (Modal.isModalOpen()) {
        return;
      }

      this.initialData();
    };
    window.addEventListener("popstate", onPopState);
    this.removePopStateListener = () => {
      window.removeEventListener("popstate", onPopState);
    };
  }

  maintainScroll() {
    if (!this.props.location.state) {
      return;
    }
    document.querySelector(".nw-app-body").style.minHeight = `${
      this.props.location.state.height
    }px`;
  }

  initInfiniteScroll() {
    const { ProductStore } = this.props;

    const infiniteScrollFn = () => {
      if (this.isListingScrollAtBottom() && ProductStore.isHavingMoreProducts) {
        if (!ProductStore.isFetchingData) {
          this.updatePageNumber();
          this.refreshData();
        }
      }

      if (this.ProductListRef) {
        this.ProductListRef.triggerChange();
      }
    };

    this.removeScrollListener = Utils.onElementScroll(
      window,
      infiniteScrollFn,
      { passive: true },
    );
  }

  isListingScrollAtBottom() {
    if (!this.listRef) {
      return false;
    }

    const windowScrollVals = Utils.windowScroll();
    const elementVals = Utils.getBoundClientRect(this.listRef);

    if (elementVals.bottom - INFINITE_SCROLL_OFFSET < windowScrollVals.bottom) {
      return true;
    }

    return false;
  }

  updatePageNumber() {
    const { ProductStore } = this.props;
    const newPageNo = ProductStore.listingPageNo + 1;

    ProductStore.setListingPageNo(newPageNo);

    this.storeScrollInState(Listing.windowLocation());
    Listing.trackPageNumber(newPageNo);
    Analytics.pageView(window.pageType);
  }

  storeScrollInState(url) {
    this.props.history.replace(url, {
      height:
        Utils.getBoundClientRect(document.querySelector(".nw-app-body"))
          .height + 100,
      ...this.currentPageStats,
    });
  }

  initialData() {
    const { ProductStore } = this.props;

    const pagePath = Listing.windowLocation();
    const pathWithPageNo = Utils.setUrlParameter(
      pagePath,
      "p",
      ProductStore.listingPageNo,
    );

    this.maintainScroll();
    BodyOverlay.show();
    ProductStore.getAllProductData(pathWithPageNo).then(
      () => {
        this.initInfiniteScroll();
        Listing.removeBodyScrollHeight();
        BodyOverlay.hide();
        this.storeScrollInState(Listing.windowLocation());
      },
      () => {
        BodyOverlay.hide();
        somethingWentWrong();
      },
    );
  }

  refreshData() {
    const { ProductStore } = this.props;

    const pagePath = Listing.windowLocation();
    const pathWithPageNo = Utils.setUrlParameter(
      pagePath,
      "p",
      ProductStore.listingPageNo,
    );

    BodyOverlay.show("nw-listingpage-transparentloader");
    ProductStore.getPageData(pathWithPageNo).then(
      () => {
        BodyOverlay.hide();
      },
      () => {
        BodyOverlay.hide();
      },
    );
  }

  render() {
    const { ProductStore } = this.props;
    const ProductData = toJS(ProductStore.ProductData);
    if (ProductData && ProductData.styles && ProductData.styles.styleList) {
      window.google_tag_params = {
        ecomm_pagetype: Event.GTMEvent.ECOMM_LISTING,
        ecomm_prodid: ProductData.styles.styleList.slice(0, 3).map(el => el.id),
      };
    }
    if (ProductData && !this.state.omniView) {
      return (
        <Fragment>
          <MobileFilterButtons />
          <StickyFilterBlock />
          <GridContainer className="nw-listingpage-container">
            <GridRow>
              {(isDesktop &&
                ProductData.totalElements > 0 && (
                  <GridColumn className="nwc-grid-col-xs nw-listingpage-filters">
                    <ProductFilters filters={ProductData.filters} />
                  </GridColumn>
                )) ||
                null}
              <GridColumn className="nwc-grid-col-xs nw-listingpage-list">
                <div
                  ref={context => {
                    this.listRef = context;
                  }}
                >
                  {/* <ListingSearchBar
                    totalElements={ProductData.totalElements}
                    queryApplied={ProductStore.queryApplied}
                  /> */}
                  <ListingBanner />
                  <ProductListTopbar />
                  {/* <SelectedFilters
                    selectedFilters={ProductData.selectedFilters}
                  /> */}
                  <ProductList
                    ref={context => {
                      this.ProductListRef = context;
                    }}
                    list={ProductData.styles.styleList}
                    totalElements={ProductData.totalElements}
                    hasMoreProducts={ProductStore.isHavingMoreProducts}
                    isAllPromotions={ProductData.isPromotionsApplied}
                  />
                </div>
              </GridColumn>
            </GridRow>
            <MobileFilterContainer />
          </GridContainer>
          <BodyOverlay />
          {/* <ListingBackToTop /> */}
        </Fragment>
      );
    } else if (this.state.omniView) {
      return (
        <OmniView
          isOpen={this.state.omniView}
          onClose={this.triggerListingAfterOmni}
          ProductStore={ProductStore}
          type={this.state.omniViewType}
          location={this.props.location}
        />
      );
    }
    return <BodyOverlay />;
  }
}

Listing.wrappedComponent.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
    state: PropTypes.object,
  }).isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
  ProductStore: PropTypes.shape({
    listingPageNo: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    collectionId: PropTypes.string.isRequired,
    clearProductData: PropTypes.func.isRequired,
    toggleFilterView: PropTypes.func.isRequired,
    isFetchingData: PropTypes.bool.isRequired,
    getAllProductData: PropTypes.func.isRequired,
    getPageData: PropTypes.func.isRequired,
    setProductData: PropTypes.func.isRequired,
    ProductData: PropTypes.object,
    isHavingMoreProducts: PropTypes.bool,
    toggleMobileFilters: PropTypes.func.isRequired,
    mobileFilterToggle: PropTypes.shape({
      refine: PropTypes.bool.isRequired,
      sortBy: PropTypes.bool.isRequired,
      activeFilter: PropTypes.string.isRequired,
    }),
  }).isRequired,
  FooterStore: PropTypes.shape({
    changeFooterVisibleState: PropTypes.func.isRequired,
  }).isRequired,
};

export default Listing;



// WEBPACK FOOTER //
// ./src/pages/Listing/index.js